import ImagePerson from "@/components/functionals/ImagePerson.vue";
import { formatDate } from "@/utils";
//import formatterModulosRRHH from "@/components/functionals/formatterModulosRRHH.vue";
export default [
  {
    prop: "Id",
    label: "ID",
    width: 100,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "NameEmployee",
    label: "Empleado",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "imageUrl"
    }
  },
  {
    prop: "WarningDate",
    label: "Fecha Amonestacion",
    width: 200,
    sortable: true,
    formatter: (props) => {
      // console.log(props)
      return formatDate(props.WarningDate, "DD/MM/YYYY");
    }
  },
  {
    prop: "Type",
    label: "Tipo",
    width: 125,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Title",
    label: "Titulo",
    width: 150,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "NameCreatorReprimand",
    label: "Amonestador",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "ImageCreatorReprimand"
    }
  }
];
